import React from "react";
import ReactDOM from "react-dom/client"; // Updated import for React 18
import "./index.css";
import App from "./App";
import VantaBackground from "./components/Camera/VantaBackground";

// Render VantaBackground outside the React app
const vantaContainer = document.createElement("div");
vantaContainer.className = "vanta-container";
document.body.appendChild(vantaContainer);
ReactDOM.createRoot(vantaContainer).render(<VantaBackground />);

// Get the root DOM element
const rootElement = document.getElementById("root");

// Create a root using ReactDOM.createRoot
const root = ReactDOM.createRoot(rootElement);

// Render the application
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
